/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";

export default {
	closeMapSideBar({commit}) {
		commit("CLOSE_MAP_SIDEBAR");
	},
	openMapSideBar({commit}) {
		commit("OPEN_MAP_SIDEBAR");
	},
	changeToggleMapSidebar({commit}, val) {
		commit("TOGGLE_MAP_SIDEBAR", val);
	},
	openPopupStreeView({commit}, val) {
		commit("OPEN_STREETVIEW", val);
	},
	getExecutedRoute({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/executed/route", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	geocoder({commit}, {country, city, address, department}) {
		const payload = {country, city, address, department};
		return new Promise((resolve, reject) => {
			Api.post("/geocoder", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
					console.error(err);
				});
		});
	},
	geoinverso({commit}, {cy, cx}) {
		const payload = {cy, cx};
		return new Promise((resolve, reject) => {
			Api.post("/geoinverso", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	convertJsonToGeojson({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/json_to_geojson", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
